<script>
  import { onMount } from 'svelte';

  let score = 0;
  let maxQuestions = 5;  // Assuming you want 20 questions per game
  let currentQuestion;
  let questionsAsked = []; // Stores the pairs of numbers used in questions
  let answeredQuestionsCount = 0;
  let feedbackMessage = '';
  let gameFinished = false; // Tracks if the game has ended
  let allPossibleQuestions = [];
  let dungeonScore = 0;

let dungeonLevel = 1;
let correctAnswersCount = 0; // Counts the number of correct answers in a set

let playerName = 'Gracz'; // Editable name field
let playerLevel = 1;
let experience = 0;
let stamina = 10; // Initial stamina value
let intellect = 10; // Initial intellect value

// For the randomly generated picture
let playerImage = generateRandomPixelImage(); // Function to create a pixel image

function generateRandomPixelImage() {
  const size = 5; // Size of the pixel art (5x5)
  const scale = 10; // Scale up the pixels for visibility
  const canvas = document.createElement('canvas');
  canvas.width = size * scale;
  canvas.height = size * scale;
  const ctx = canvas.getContext('2d');

  for (let x = 0; x < size; x++) {
    for (let y = 0; y < size; y++) {
      ctx.fillStyle = `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${Math.random() * 255})`;
      ctx.fillRect(x * scale, y * scale, scale, scale);
    }
  }

  return canvas.toDataURL();
}



function initializeQuestions() {
  const maxNumberA = 5;
  const maxNumberB = 10;
  for (let i = 1; i <= maxNumberA; i++) {
    for (let j = i; j <= maxNumberB; j++) {
      allPossibleQuestions.push({ number1: i, number2: j });
    }
  }

  // Shuffle the array
  allPossibleQuestions.sort(() => Math.random() - 0.5);
}

  onMount(() => {
    initializeQuestions();
    nextQuestion();
  });

function generateQuestion() {
  if (allPossibleQuestions.length === 0) {
    initializeQuestions();
//    return null; // Return null to indicate no more questions are available
  }

  const { number1, number2 } = allPossibleQuestions.pop(); // Get a question pair
  let correctAnswer = number1 * number2;

  let answers = new Set([correctAnswer]);
  while (answers.size < 4) {
    let wrongAnswer = Math.ceil(Math.random() * 10 * 10); // Generate wrong answers
    if (wrongAnswer !== correctAnswer) {
      answers.add(wrongAnswer);
    }
  }

  answers = Array.from(answers);
  for (let i = answers.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [answers[i], answers[j]] = [answers[j], answers[i]]; // Shuffle answers
  }

  const minecraftEntities = [
  'Troll',
  'Duszek',
  'Zombie',     // Commonly used in English even in Polish
  'Creeper',    // Commonly used in English even in Polish
  'Szkielet',   // Skeleton
  'Pająk',      // Spider
  'Enderman',   // Commonly used in English even in Polish
  'Wiedźma',    // Witch
  'Wieśniak',   // Villager
  'Osadnik',    // Pillager
  'Kość',       // Skeleton Horse
  'Kurczak',    // Chicken
  'Krowa',      // Cow
  'Świnia',     // Pig
  'Baran',      // Sheep
  'Ocelot'      // Commonly used in English even in Polish
];

  let monster = minecraftEntities[Math.floor(Math.random() * minecraftEntities.length)];

  return {
    question: `${monster} pyta: "Ile jest ${number1} * ${number2}?"`,
    answers: answers,
    number1,
    number2
  };
}

  function nextQuestion() {
    if (questionsAsked.length >= maxQuestions) {
      endGame();
      return;
    }

    let newQuestion = generateQuestion();
    currentQuestion = newQuestion;
    questionsAsked.push({ number1: newQuestion.number1, number2: newQuestion.number2 });
    feedbackMessage = ''; // Reset feedback message for the next question
  }

  function checkAnswer(answer) {
    answeredQuestionsCount++;

    const [num1, num2] = currentQuestion.question.match(/\d+/g).map(Number);
    const correctAnswer = num1 * num2;

    if (answer === correctAnswer) {
      score++;
      correctAnswersCount++;
      experience += Math.ceil(Math.random() * 4) + 1;
      feedbackMessage = getRandomCongratulation();
    } else {
      //experience += Math.ceil(Math.random() * 2);
      feedbackMessage = getEncouragement();
    }

    updatePlayerStats();
    nextQuestion();
  }

function updatePlayerStats() {
  while (experience >= 15) { // Level up every 15 experience points
    experience -= 15;
    playerLevel++;
    stamina += 1; // Increase stamina every level
    if (playerLevel % 2 === 0) {
      intellect += 1; // Increase intellect every second level
    }
  }
}

  function getRandomCongratulation() {
    const congratulations = ["Świetna robota!", "Dobrze zrobione!", "Brawo, tak trzymaj!"];
    return congratulations[Math.floor(Math.random() * congratulations.length)];
  }

  function getEncouragement() {
    const encouragements = ["Nie martw się, spróbuj jeszcze raz!", "Prawie się udało, próbuj dalej!", "Nie poddawaj się, na pewno się uda!"];
    return encouragements[Math.floor(Math.random() * encouragements.length)];
  }

function endGame() {
  dungeonScore = Math.round(100*correctAnswersCount/maxQuestions);

  // Check if more than 60% answers were correct
  if (correctAnswersCount / maxQuestions >= 0.6) {
    dungeonLevel++;
    maxQuestions += 2;
  }

  gameFinished = true;
  correctAnswersCount = 0; // Reset for next set
}

  function restartGame() {
    score = 0;
    questionsAsked = [];
    gameFinished = false;
    answeredQuestionsCount = 0;
    feedbackMessage = '';
    nextQuestion();
  }
</script>

<div class="player-profile">
  <h3>⚔️ {playerName} ⚔️</h3>
  <!--<input type="text" bind:value={playerName} />-->
  <img src={playerImage} alt="Player Image" />
  <p>Poziom: {playerLevel}</p>
  <p>Doświadczenie: {experience}</p>
  <p>Wytrzymałość: {stamina}</p>
  <p>Intelekt: {intellect}</p>
</div>

<main class="fadeIn">
  <h1>🌟 Gra 🌟</h1>
  <p class="dungeon-info">Jesteś w lochu na poziomie: {dungeonLevel}</p>
  {#if gameFinished}
    <p>Wynik: {dungeonScore}%</p>
    <br/>
    <br/>
    <br/>
    {#if dungeonScore > 60}
    <button on:click={restartGame}>Awansujesz!</button>
    {:else}
    <button on:click={restartGame}>Dawaj jeszcze raz!</button>
    {/if}
  {:else}
    {#if currentQuestion}
      <p>{currentQuestion.question}</p>
      {#each currentQuestion.answers as answer}
        <button on:click={() => checkAnswer(answer)}>{answer}</button>
      {/each}
      {#if feedbackMessage}
        <p class="feedback">{feedbackMessage}</p>
      {/if}
    {/if}
    <p class="score">Wynik: {score}</p>
    <p>Pokonano {answeredQuestionsCount} przeciwników z {maxQuestions}</p>
  {/if}
</main>

<style>
/* General Styles */
main {
  font-family: 'Arial Rounded MT Bold', 'Verdana', 'Tahoma', sans-serif;
  text-align: center;
  background-color: #ffccff; /* Light pink background */
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  margin: auto;
  width: 85%;
  max-width: 800px;
  min-width: 300px;
}

h1 {
  color: #ff66cc; /* Pinkish color for the heading */
  text-shadow: 2px 2px 4px #ffaabb;
  font-size: 2em; /* Adjusted for relative sizing */
  margin-bottom: 20px;
}

p {
  font-size: 1.2em;
  color: #333366; /* Dark blue color for text */
}

button {
  background-color: #66ccff; /* Sky blue background for buttons */
  color: white;
  border: none;
  padding: 10px 20px;
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0 5px #0099cc;
  font-size: 1em;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover {
  background-color: #55bbff;
  transform: translateY(-2px);
  box-shadow: 0 7px #0088bb;
}

button:active {
  transform: translateY(0);
  box-shadow: 0 5px #0099cc;
}

.score {
  font-size: 1.8em;
  font-weight: bold;
  color: black; /* Orange color for the score */
  margin-top: 15px;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 2s;
}

.feedback {
  margin-top: 15px;
  font-size: 1.2em;
  color: #0066cc; /* Feel free to choose a suitable color */
}

/* Player Profile Styles */
.player-profile {
  font-family: 'Arial Rounded MT Bold', 'Verdana', 'Tahoma', sans-serif;
  background-color: #f0eaff; /* Light purple background */
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  margin: 10px;
  width: 200px; /* Adjust width as needed */
  float: right; /* Float aside */
  animation: slideIn 1s ease;
}

.player-profile input[type="text"] {
  font-size: 1.2em;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  box-sizing: border-box; /* Ensures padding doesn't increase width */
}

.player-profile img {
  display: block;
  margin: 10px auto;
  border-radius: 50%;
  width: 80px; /* Adjust as needed */
  height: 80px;
}

/* Responsive Design for Mobile Devices */
@media (max-width: 600px) {
  .player-profile {
    float: none;
    width: 100%;
    margin: 0 auto 20px;
    order: -1; /* Move profile above main content */
  }

  main {
    width: 100%;
    max-width: none;
    padding: 20px;
  }

  button {
    padding: 12px;
    font-size: 1em;
    margin: 5px;
    width: calc(50% - 10px); /* Two buttons per row */
  }

  .feedback, .score, p.dungeon-info {
    font-size: 1em;
  }

  h1 {
    font-size: 1.6em;
  }
}

main p.dungeon-info {
  font-size: 1.5em;
  color: #ffcc00; /* Gold color for dungeon info */
  text-shadow: 1px 1px 2px #000;
  margin-top: 10px;
}

</style>

